import type { LocalizationDictionary } from "@slot/game-shell";

// This title's words, in two places: this compiled English (the boot-time fallback for what its code shows), and the
// served `game.<locale>.json` in `assets-src/game-shared-visuals/localization/`, merged over the shell's dictionary,
// which also carries the info page's text. The parity test holds them together.

export const gameEnDictionary: LocalizationDictionary = {
  "pots.life": "LIFE",
  "pots.multi": "MULTI",
  "pots.grow": "GROW",
  "intro.features": "BONUS GAME FEATURES",
  "lines.title": "LINES",
  "featuretrigger.title": "HOLD & WIN",
  "featuretrigger.subtitle": "RESPINS",
  "featuretrigger.noBoosters": "Fill the pots to start with boosters",
  "featurefinished.title": "TOTAL WIN",
  "featurefinished.subtitle": "HOLD & WIN COMPLETE",
  "bigwin.big": "BIG WIN",
  "bigwin.mega": "MEGA WIN",
  "bigwin.epic": "EPIC WIN",
  "feature_purchase.bonus_random.title": "Random Boost",
  "feature_purchase.bonus_random.description": "Start Hold & Win with 1 to 3 random boosters.",
  "feature_purchase.bonus_trio.title": "Booster Trio",
  "feature_purchase.bonus_trio.description": "Start Hold & Win with LIFE, MULTI and GROW.",
  "feature_purchase.bonus_madness.title": "Multi Madness",
  "feature_purchase.bonus_madness.description": "All three boosters, and MULTI erupts on every respin.",
};
